import { DialogBody, DialogHeader } from '@design-system/dialog';
import AddonToggle from '../components/addon-toggle';
import AddonCard from '../components/addon-card';
import { mockAddonPlansAndPricing } from '@features/settings/pages/billing/pricing/mock-data';

const AddonsDialog = () => {
  return (
    <>
      <DialogHeader>Add-Ons</DialogHeader>
      <DialogBody>
        <p className='text-gray-800 font-medium text-lg'>Advanced Add-ons</p>
        <p className='text-gray-600 font-normal text-sm'>
          Choose the package that suits your needs
        </p>
        <div className='flex justify-center'>
          <AddonToggle />
        </div>

        <div className='grid grid-cols-2 md:grid-cols-5 gap-4 mt-4'>
          {mockAddonPlansAndPricing.map((plan) => (
            <AddonCard
              key={plan.id}
              plan={plan}
            />
          ))}
        </div>
      </DialogBody>
    </>
  );
};

export default AddonsDialog;
